import $ from 'jquery';
import AccountService from '../../_shared/account-service';
import applyAccessRoles from '../helpers/apply-access-roles';
import { isRtl } from '../../_shared/helpers';
import setReturnUrls from '../helpers/set-return-urls';
import PrimaryNav from './primary-nav';
import SecondaryNav from './secondary-nav';
import FlyOuts from './fly-outs';
import StickToTop from './stick-to-top';
import TopBanner from './top-banner';

export default class MainHeader {
  constructor(mainHeaderSelector, outerUsage) {
    this.$header = $(mainHeaderSelector);
    this.outerUsage = !!outerUsage;

    this.primaryNav = new PrimaryNav(this.$header);
    this.secondaryNav = new SecondaryNav(this.$header);
    this.flyOuts = new FlyOuts(this.$header);
    this.sticky = new StickToTop(this.$header);
    this.topBanner = new TopBanner(this.$header);

    this.init();
  }

  async init() {
    this.isInitialized = true;

    if (!this.$header.length) {
      this.isInitialized = false;

      return;
    }

    const userData = await AccountService.getUserData(true);

    applyAccessRoles(this.$header, userData);

    setReturnUrls(this.$header);

    this.primaryNav.init();
    this.secondaryNav.init(userData);
    this.flyOuts.init();

    /**
     * @desc Microsoft Edge 12-18 (all EdgeHTML) Not Chromium
     */
    const isEdgeBrowser = window.CSS.supports('-ms-ime-align', 'auto');

    if (!(isEdgeBrowser && isRtl())) {
      this.sticky.init();
    }

    this.topBanner.init();
  }
}
